import { createContext } from 'react';

type TimeContextType = {
  isHalfTime: () => boolean,
  isFinalTime: () => boolean,
  isLoading: boolean,
}

export const TimeContext = createContext<TimeContextType>({isHalfTime: () => false, isFinalTime: () => false, isLoading: true})
